export default "/_next/static/images/42f815eee0ea1661d07df5a1fbb81549.jpg";